(function () {
  function initModal() {
    if (typeof MicroModal !== 'undefined') {
      MicroModal.init({
        disableScroll: true,
        awaitOpenAnimation: true,
        openClass: 'Modal--is-open'
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initModal();
  });
})();
